export default '1.2.3';



/** WEBPACK FOOTER **
 ** ./src/lib/version.js
 **/